import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaPlanoContaFinanceiroModel } from "../models/planoContaFinanceiro/buscaPlanoContaFinanceiroModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarPlanoContaFinanceiro, setModalDeletarPlanoContaFinanceiro } from "../redux/slices/planoContaFinanceiro/planoContaFinanceiroSlice";

export const cadastrarPlanoContaFinanceiro = createAsyncThunk("/PlanoContaFinanceiro/CadastrarPlanoContaFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/PlanoContaFinanceiro/CadastrarPlanoContaFinanceiro/", payload.value);
    toastSucess("Item do plano de conta financeiro cadastrado com sucesso");
    dispatch(setModalCadastrarPlanoContaFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarPlanoContaFinanceiro = createAsyncThunk("/PlanoContaFinanceiro/BuscarPlanoContaFinanceiro", async (args: BuscaPlanoContaFinanceiroModel) => {
  try {
    const data = await api.get("/PlanoContaFinanceiro/BuscarPlanoContaFinanceiro", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

// export const buscarPlanoContaFinanceiroAtivosGrupoTreeSelect = createAsyncThunk(
//   "/PlanoContaFinanceiro/BuscarPlanoContaFinanceiroAtivosGrupoTreeSelect",
//   async (idGrupoPlanoContaFinanceiro: number) => {
//     try {
//       const data = await api.get("/PlanoContaFinanceiro/BuscarPlanoContaFinanceiroAtivosGrupoTreeSelect", { params: { idGrupoPlanoContaFinanceiro: idGrupoPlanoContaFinanceiro } });
//       return data.data.data;
//     } catch (error: any) {
//       throw new Error(error.response.data.Message);
//     }
//   }
// );

// export const listarPlanoContaFinanceiroAtivosTreeSelect = createAsyncThunk("/PlanoContaFinanceiro/ListarPlanoContaFinanceiroAtivosTreeSelect", async () => {
//   try {
//     const data = await api.get("/PlanoContaFinanceiro/ListarPlanoContaFinanceiroAtivosTreeSelect");
//     return data.data.data;
//   } catch (error: any) {
//     throw new Error(error.response.data.Message);
//   }
// });

// export const listarPlanoContaFinanceiroAtivos = createAsyncThunk("/PlanoContaFinanceiro/ListarPlanoContaFinanceiroAtivos", async () => {
//   try {
//     const data = await api.get("/PlanoContaFinanceiro/ListarPlanoContaFinanceiroAtivos");
//     return data.data.data;
//   } catch (error: any) {
//     throw new Error(error.response.data.Message);
//   }
// });

export const listarHistoricoPlanoContaFinanceiro = createAsyncThunk("/PlanoContaFinanceiro/ListarHistoricoPlanoContaFinanceiro", async (idPlanoContaFinanceiro: number) => {
  try {
    const data = await api.get("/PlanoContaFinanceiro/ListarHistoricoPlanoContaFinanceiro", { params: { idPlanoContaFinanceiro: idPlanoContaFinanceiro } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarPlanoContaFinanceiro = createAsyncThunk("/PlanoContaFinanceiro/AtualizarPlanoContaFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/PlanoContaFinanceiro/AtualizarPlanoContaFinanceiro/", payload.value);
    toastSucess("Item do plano de conta financeiro atualizado com sucesso");
    dispatch(setModalCadastrarPlanoContaFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarPlanoContaFinanceiroAtivo = createAsyncThunk("/PlanoContaFinanceiro/AtualizarPlanoContaFinanceiroAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/PlanoContaFinanceiro/AtualizarPlanoContaFinanceiroAtivo", null, { params: payload.value });
    toastSucess("Status de ativo do item do plano de conta financeiro atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarPlanoContaFinanceiroRedutor = createAsyncThunk("/PlanoContaFinanceiro/AtualizarPlanoContaFinanceiroRedutor", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/PlanoContaFinanceiro/AtualizarPlanoContaFinanceiroRedutor", null, { params: payload.value });
    toastSucess("Status de redutor do item do plano de conta financeiro atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarPlanoContaFinanceiro = createAsyncThunk("/PlanoContaFinanceiro/DeletarPlanoContaFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/PlanoContaFinanceiro/DeletarPlanoContaFinanceiro", { params: { id: payload.value } });
    toastSucess("Item do plano de conta financeiro removido com sucesso");
    dispatch(setModalDeletarPlanoContaFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
